import { call, put, takeLatest } from "redux-saga/effects";
import { deletePsychologistSchedule, deletePsychologistScheduleDone, deletePsychologistScheduleFail, deletePsychologistWork, deletePsychologistWorkDone, deletePsychologistWorkFail, getPsychologistSchedule, getPsychologistScheduleByID, getPsychologistScheduleByIDDone, getPsychologistScheduleByIDFail, getPsychologistScheduleDone, getPsychologistScheduleFail, getPsychologistTeachers, getPsychologistTeachersDone, getPsychologistTeachersFail, getPsychologistWork, getPsychologistWorkByOne, getPsychologistWorkByOneDone, getPsychologistWorkByOneFail, getPsychologistWorkDone, getPsychologistWorkFail, getPsychologistWorkFilter, getPsychologistWorkFilterDone, getPsychologistWorkFilterFail, getPsychologistWorkGroup, getPsychologistWorkGroupDone, getPsychologistWorkGroupFail, getPsychologistWorkGroupStudents, getPsychologistWorkGroupStudentsDone, getPsychologistWorkGroupStudentsFail, postPsychologistSchedule, postPsychologistScheduleDone, postPsychologistScheduleFail, postPsychologistWork, postPsychologistWorkDone, postPsychologistWorkFail, putPsychologistSchedule, putPsychologistScheduleDone, putPsychologistScheduleFail, putPsychologistWork, putPsychologistWorkDone, putPsychologistWorkFail } from "./actions";
import { deletePsychologistScheduleApi, deletePsychologistWorkApi, getPsychologistGroupApi, getPsychologistGroupByIDApi, getPsychologistScheduleApi, getPsychologistScheduleByIDApi, getPsychologistTeachersApi, getPsychologistWorkApi, getPsychologistWorkByOneApi, getPsychologistWorkFilterApi, postPsychologistScheduleApi, postPsychologistWorkApi } from "./api";

import { PayloadAction } from "@reduxjs/toolkit";


function* getPsychologistScheduleFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(getPsychologistScheduleApi, payload)

    if (data?.data) {
      yield put(getPsychologistScheduleDone(data?.data))
    }
  } catch (e) {
    yield put(getPsychologistScheduleFail())
  }
}

function* getPsychologistScheduleByIDFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(getPsychologistScheduleByIDApi, payload)

    if (data?.data) {
      yield put(getPsychologistScheduleByIDDone(data?.data))
    }
  } catch (e) {
    yield put(getPsychologistScheduleByIDFail())
  }
}

function* postPsychologistScheduleFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(postPsychologistScheduleApi, payload)

    if (data?.data) {
      yield put(postPsychologistScheduleDone(data?.data))
    }
  } catch (e) {
    yield put(postPsychologistScheduleFail())
  }
}

function* putPsychologistScheduleFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(postPsychologistScheduleApi, payload)

    if (data?.data) {
      yield put(putPsychologistScheduleDone(data?.data))
    }
  } catch (e) {
    yield put(putPsychologistScheduleFail())
  }
}

function* deletePsychologistScheduleFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(deletePsychologistScheduleApi, payload)

    if (data?.data) {
      yield put(deletePsychologistScheduleDone(data?.data))
    }
  } catch (e) {
    yield put(deletePsychologistScheduleFail())
  }
}

function* getPsychologistWorkFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(getPsychologistWorkApi, payload)

    if (data?.data) {
      yield put(getPsychologistWorkDone(data?.data))
    }
  } catch (e) {
    yield put(getPsychologistWorkFail())
  }
}

function* getPsychologistWorkByIDFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(getPsychologistWorkByOneApi, payload)

    if (data?.data) {
      yield put(getPsychologistWorkByOneDone(data?.data))
    }
  } catch (e) {
    yield put(getPsychologistWorkByOneFail())
  }
}

function* postPsychologistWorkFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(postPsychologistWorkApi, payload)

    if (data?.data) {
      yield put(postPsychologistWorkDone(data?.data))
    }
  } catch (e) {
    yield put(postPsychologistWorkFail())
  }
}

function* putPsychologistWorkFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(postPsychologistWorkApi, payload)

    if (data?.data) {
      yield put(putPsychologistWorkDone(data?.data))
    }
  } catch (e) {
    yield put(putPsychologistWorkFail())
  }
}

function* deletePsychologistWorkFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(deletePsychologistWorkApi, payload)

    if (data?.data) {
      yield put(deletePsychologistWorkDone(data?.data))
    }
  } catch (e) {
    yield put(deletePsychologistWorkFail())
  }
}

function* getPsychologistWorkFilterFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(getPsychologistWorkFilterApi, payload)

    if (data?.data) {
      yield put(getPsychologistWorkFilterDone(data?.data))
    }
  } catch (e) {
    yield put(getPsychologistWorkFilterFail())
  }
}


function* getPsychologistWorkGroupFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(getPsychologistGroupApi)

    if (data?.data) {
      yield put(getPsychologistWorkGroupDone(data?.data))
    }
  } catch (e) {
    yield put(getPsychologistWorkGroupFail())
  }
}


function* getPsychologistWorkGroupStudentsFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(getPsychologistGroupByIDApi, payload)

    if (data?.data) {
      yield put(getPsychologistWorkGroupStudentsDone(data?.data))
    }
  } catch (e) {
    yield put(getPsychologistWorkGroupStudentsFail())
  }
}

function* getPsychologistTeachersFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(getPsychologistTeachersApi, payload)

    if (data?.data) {
      yield put(getPsychologistTeachersDone(data?.data))
    }
  } catch (e) {
    yield put(getPsychologistTeachersFail())
  }
}

export default function* psychologistSaga() {
  yield takeLatest(getPsychologistSchedule, getPsychologistScheduleFlow);
  yield takeLatest(getPsychologistScheduleByID, getPsychologistScheduleByIDFlow);
  yield takeLatest(postPsychologistSchedule, postPsychologistScheduleFlow);
  yield takeLatest(putPsychologistSchedule, putPsychologistScheduleFlow);
  yield takeLatest(deletePsychologistSchedule, deletePsychologistScheduleFlow);

  yield takeLatest(getPsychologistWork, getPsychologistWorkFlow);
  yield takeLatest(getPsychologistWorkByOne, getPsychologistWorkByIDFlow);
  yield takeLatest(postPsychologistWork, postPsychologistWorkFlow);
  yield takeLatest(putPsychologistWork, putPsychologistWorkFlow);
  yield takeLatest(deletePsychologistWork, deletePsychologistWorkFlow);
  yield takeLatest(getPsychologistWorkFilter, getPsychologistWorkFilterFlow);
  yield takeLatest(getPsychologistWorkGroup, getPsychologistWorkGroupFlow);
  yield takeLatest(getPsychologistWorkGroupStudents, getPsychologistWorkGroupStudentsFlow);
  yield takeLatest(getPsychologistTeachers, getPsychologistTeachersFlow);
}
